import {
  GET_BACKOFFICE_LIST,
  GET_BO_ACTIVITY_TYPE,
  GET_BO_APQC,
  GET_BO_APQC_LIB,
  GET_BO_BOARD_EMPLOYEE,
  GET_BO_BOARD_PROCESS,
  GET_BO_BOARD_STRUCTURE,
  GET_BO_CATEGORY_GROUP,
  GET_BO_CLASSIFICATION,
  GET_BO_COMPANY_BOARD,
  GET_BO_COMPETENCY_DETAIL,
  GET_BO_COMPETENCY_LIBRARY,
  GET_BO_CREATE_STRUCTURE,
  GET_BO_CUSTOM_ORG_PARAMETER,
  GET_BO_DASHBOARD,
  GET_BO_DETAIL_STRUCTURE,
  GET_BO_DIRECTORATE,
  GET_BO_FEATURE,
  GET_BO_FTE,
  GET_BO_JOB_LEVEL,
  GET_BO_LEVEL_DESCRIPTION,
  GET_BO_LOG_LIST,
  GET_BO_LOG_LIST_FEATURE,
  GET_BO_MEMBER,
  GET_BO_REGION,
  GET_BO_REPORT_TO,
  GET_BO_SKILL_GROUP,
  GET_BO_SUB_SKILL_GROUP,
  GET_BO_SUBSCRIPTION_LIST,
  GET_BO_USER_LIST,
  GET_BO_WORKER_TYPE,
  GET_COMPETENCY,
  GET_WORKLOAD_LIST,
} from 'redux/actions/backOffice';
import { GET_APQC_LIB } from 'redux/actions/business_process';

const initialState = {
  company: [],
  subscription: [],
  user: [],
  log: [],
  log_list_feature: [],
  dashboard: [],
  feature_list: [],
  apqc: {
    list: [],
    view: [],
  },
  workload: [],
  // company-compSetting
  bo_list_category_group: [],
  bo_list_act_classification: [],
  bo_list_act_type: [],
  bo_comp_library: {
    core_competency: [],
    leadership_competency: [],
    technical_competency: [],
    functional_competency: [],
  },
  bo_competency_structure: {
    core_competency: [],
    leadership_competency: [],
    technical_competency: [],
    functional_competency: [],
  },
  bo_list_org_parameter: [],
  bo_list_directorate: [],
  bo_list_fte: [],
  bo_list_level_desc: [],
  bo_list_member: [],
  bo_list_region: [],
  bo_list_skill_group: [],
  bo_list_sub_skill_group: [],
  bo_list_worker_type: [],
  // company-board
  bo_list_board: [],
  bo_list_process: [],
  bo_list_structure: [],
  bo_total_structure: 0,
  bo_detail_structure: null,
  bo_list_employee: [],
  bo_total_employee: 0,
  bo_job_level: [],
  bo_report_to: [],
  bo_competency_detail: [],
};
// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_BACKOFFICE_LIST: {
      return {
        ...state,
        company: payload,
      };
    }
    case GET_BO_SUBSCRIPTION_LIST: {
      return {
        ...state,
        subscription: payload,
      };
    }
    case GET_BO_USER_LIST: {
      return {
        ...state,
        user: payload,
      };
    }
    case GET_BO_LOG_LIST: {
      return {
        ...state,
        log: payload,
      };
    }
    case GET_BO_DASHBOARD: {
      return {
        ...state,
        dashboard: payload,
      };
    }
    case GET_BO_FEATURE: {
      return {
        ...state,
        feature_list: payload,
      };
    }
    case GET_BO_APQC_LIB: {
      return {
        ...state,
        apqc: {
          list: payload,
        },
      };
    }
    case GET_BO_APQC: {
      state.apqc.view = [];
      return {
        ...state,
        apqc: {
          ...state.apqc,
          view: payload,
        },
      };
    }
    case GET_BO_LOG_LIST_FEATURE: {
      state.apqc.view = [];
      return {
        ...state,
        log_list_feature: payload,
      };
    }
    case GET_WORKLOAD_LIST: {
      return {
        ...state,
        workload: {
          list: payload,
        },
      };
    }
    case GET_COMPETENCY: {
      return {
        ...state,
        list_competency: payload,
      };
    }
    // Company-CompSetting
    case GET_BO_CATEGORY_GROUP: {
      return {
        ...state,
        bo_list_category_group: payload.data,
      };
    }
    case GET_BO_CLASSIFICATION: {
      return {
        ...state,
        bo_list_act_classification: payload.data,
      };
    }
    case GET_BO_ACTIVITY_TYPE: {
      return {
        ...state,
        bo_list_act_type: payload.data,
      };
    }
    case GET_BO_COMPETENCY_LIBRARY: {
      const rawData = payload?.datas?.data || [];
      const cleanData = rawData.map(({ competency_detail, ...rest }) => rest);
      return {
        ...state,
        bo_comp_library: {
          ...state.bo_comp_library,
          [payload.type]: cleanData,
        },
        bo_competency_structure: {
          ...state.bo_competency_structure,
          [payload.type]: rawData,
        },
      };
    }
    case GET_BO_CUSTOM_ORG_PARAMETER: {
      return {
        ...state,
        bo_list_org_parameter: payload.data,
      };
    }
    case GET_BO_DIRECTORATE: {
      return {
        ...state,
        bo_list_directorate: payload.data,
      };
    }
    case GET_BO_FTE: {
      return {
        ...state,
        bo_list_fte: payload.data,
      };
    }
    case GET_BO_LEVEL_DESCRIPTION: {
      return {
        ...state,
        bo_list_level_desc: payload.data,
      };
    }
    case GET_BO_MEMBER: {
      return {
        ...state,
        bo_list_member: payload.data,
      };
    }
    case GET_BO_REGION: {
      return {
        ...state,
        bo_list_region: payload.data,
      };
    }
    case GET_BO_SKILL_GROUP: {
      return {
        ...state,
        bo_list_skill_group: payload.data,
      };
    }
    case GET_BO_SUB_SKILL_GROUP: {
      return {
        ...state,
        bo_list_sub_skill_group: payload.data,
      };
    }
    case GET_BO_COMPETENCY_DETAIL: {
      return {
        ...state,
        bo_competency_detail: payload.data,
      };
    }
    case GET_BO_WORKER_TYPE: {
      return {
        ...state,
        bo_list_worker_type: payload.data,
      };
    }
    // Company-Board
    case GET_BO_COMPANY_BOARD: {
      return {
        ...state,
        bo_list_board: payload.data,
      };
    }
    case GET_BO_BOARD_PROCESS: {
      return {
        ...state,
        bo_list_process: payload.data,
      };
    }
    case GET_BO_DETAIL_STRUCTURE: {
      return {
        ...state,
        bo_detail_structure: payload.data,
      };
    }
    case GET_BO_BOARD_STRUCTURE: {
      return {
        ...state,
        bo_list_structure: payload.data,
        bo_total_structure: payload.count,
      };
    }
    case GET_BO_BOARD_EMPLOYEE: {
      return {
        ...state,
        bo_list_employee: payload.data,
        bo_total_employee: payload.count,
      };
    }

    case GET_BO_JOB_LEVEL: {
      return {
        ...state,
        bo_job_level: payload,
      };
    }

    default:
      return state;
  }
};
